<template>
    <div>
        <div class="seo">{{ data['field_2'] }}</div>
        <youtube :video-id="data['field_1']" :player-vars="{ rel: 0 }" ref="youtube" @playing="playing" :resize="true">
        <img :src="data['field_3']" />
        </youtube>
        <!-- <button @click="playVideo">play</button> -->
    </div>
</template>
<script>
export default {
    props: {
        data: {
            type: Object
        }
    },
    data() {
        return {};
    },
    mounted() {
        // console.log("this.data", this.data);
    },
    methods: {
        playVideo() {
            this.player.playVideo();
        },
        playing() {
        }
    },
    computed: {
        player() {
            return this.$refs.youtube.player;
        }
    }
};
</script>
<style scoped>
iframe {
  width: 100%;
  max-width: 650px; /* Also helpful. Optional. */
}
</style>
